"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _reactComponents = require("@ui-propulsion/react-components");
var _ = require(".");
var _util = require("../../util");
var BLOCK_CLASS = 'revisions-revisor';
var Revisor = function Revisor(_ref) {
  var maxPayeeCount = _ref.maxPayeeCount,
    offers = _ref.offers,
    creditLimit = _ref.creditLimit,
    tooltip = _ref.tooltip,
    physicalState = _ref.physicalState,
    mailingAddressState = _ref.mailingAddressState,
    productType = _ref.productType,
    register = _ref.register,
    watch = _ref.watch,
    getValues = _ref.getValues,
    formState = _ref.formState,
    control = _ref.control,
    _onAddProvider = _ref.onAddProvider,
    handleAmountChange = _ref.handleAmountChange,
    _onPayeeRemove = _ref.onPayeeRemove;
  var _useFieldArray = (0, _reactHookForm.useFieldArray)({
      name: 'payees',
      control: control
    }),
    fields = _useFieldArray.fields,
    remove = _useFieldArray.remove;
  var errors = formState.errors;
  var isMAFRPLoan = [physicalState, mailingAddressState].includes('MA') && _util.FIXED_RATE_PLANS.includes(productType);
  var minAmount = isMAFRPLoan ? _util.MIN_MASSACHUSETTS_AMT : Math.min.apply(Math, (0, _toConsumableArray2.default)(offers.map(function (_ref2) {
    var minimumAmount = _ref2.minimumAmount;
    return parseInt(minimumAmount, 10);
  })));
  var maxAmount = Math.max.apply(Math, (0, _toConsumableArray2.default)(offers.map(function (_ref3) {
    var maximumAmount = _ref3.maximumAmount;
    return parseInt(maximumAmount, 10);
  })));
  var bem = (0, _util.bemClass)(BLOCK_CLASS);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: BLOCK_CLASS
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: bem('centered-container')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: bem('available-credit')
  }, "Available credit: ", (0, _util.toDollar)(creditLimit)), fields.length <= 1 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.SinglePayeeView, null, /*#__PURE__*/_react.default.createElement(_.CurrencyTextBox, {
    errors: errors,
    index: 0,
    register: register,
    minAmount: minAmount,
    maxAmount: maxAmount,
    handleAmountChange: handleAmountChange
  })), maxPayeeCount > 1 && /*#__PURE__*/_react.default.createElement(_.AddProviderButton, {
    tooltip: tooltip,
    onAddProvider: function onAddProvider(e) {
      return _onAddProvider(e, getValues());
    }
  })) : /*#__PURE__*/_react.default.createElement(_.MultiPayeeView, null, /*#__PURE__*/_react.default.createElement(_.PayeeList, {
    fields: fields
  }, function (field, index) {
    return /*#__PURE__*/_react.default.createElement(_.Payee, {
      key: field.id,
      field: field,
      index: index,
      register: register,
      minAmount: minAmount,
      maxAmount: maxAmount,
      errors: errors,
      handleAmountChange: handleAmountChange,
      onPayeeRemove: function onPayeeRemove(i) {
        remove(i);
        _onPayeeRemove();
      }
    }, /*#__PURE__*/_react.default.createElement(_.CurrencyTextBox, {
      errors: errors,
      index: index,
      register: register,
      minAmount: minAmount,
      maxAmount: maxAmount,
      handleAmountChange: handleAmountChange
    }));
  }), /*#__PURE__*/_react.default.createElement(_.AddProviderButton, {
    disabled: maxPayeeCount <= fields.length,
    tooltip: tooltip,
    onAddProvider: function onAddProvider(e) {
      return _onAddProvider(e, getValues());
    }
  }), /*#__PURE__*/_react.default.createElement(_reactComponents.Divider, {
    style: {
      borderTopWidth: '2px',
      borderTopColor: '#000'
    }
  }), /*#__PURE__*/_react.default.createElement(_.TotalAmount, {
    fields: watch('payees')
  }))));
};
Revisor.propTypes = {
  maxPayeeCount: _propTypes.default.number.isRequired,
  offers: _propTypes.default.arrayOf(_propTypes.default.shape({
    minimumAmount: _propTypes.default.string,
    maximumAmount: _propTypes.default.string
  })).isRequired,
  creditLimit: _propTypes.default.string.isRequired,
  tooltip: _propTypes.default.string,
  physicalState: _propTypes.default.string.isRequired,
  mailingAddressState: _propTypes.default.string,
  productType: _propTypes.default.string.isRequired,
  register: _propTypes.default.func.isRequired,
  watch: _propTypes.default.func.isRequired,
  getValues: _propTypes.default.func.isRequired,
  formState: _propTypes.default.shape({
    errors: _propTypes.default.objectOf(_propTypes.default.array)
  }).isRequired,
  control: _propTypes.default.shape({
    register: _propTypes.default.func
  }).isRequired,
  onAddProvider: _propTypes.default.func,
  handleAmountChange: _propTypes.default.func.isRequired,
  onPayeeRemove: _propTypes.default.func.isRequired
};
Revisor.defaultProps = {
  tooltip: '',
  mailingAddressState: '',
  onAddProvider: null
};
var _default = Revisor;
exports.default = _default;
